(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autoplay-video"] && !window.DesignMode) return;
  try {
    
class VideoController {
  constructor(container) {
    this.container = container;
    this.video = container.querySelector('.video-player');
    this.isUsingCustomControls = container.dataset.controls === 'false';
    
    // Only initialize if video exists and we're using custom controls
    if (this.video && this.isUsingCustomControls) {
      this.thumbnail = container.querySelector('.video-thumbnail-wrapper');
      this.playPauseBtn = container.querySelector('[data-action="toggle-play"]');
      this.playIcon = this.playPauseBtn?.querySelector('.play-icon');
      this.pauseIcon = this.playPauseBtn?.querySelector('.pause-icon');
      
      // Debug logs
      console.log('Video Controller Initialized:', {
        hasVideo: !!this.video,
        hasCustomControls: this.isUsingCustomControls,
        hasPlayPauseBtn: !!this.playPauseBtn
      });

      this.init();
    }
  }

  init() {
    if (!this.video) return;
    
    // Handle play/pause button clicks
    if (this.playPauseBtn) {
      this.playPauseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.togglePlayPause();
      });
    }
    
    // Handle thumbnail click
    if (this.thumbnail) {
      this.thumbnail.addEventListener('click', () => {
        this.thumbnail.style.display = 'none';
        this.video.closest('.video-wrapper').classList.remove('hide-video');
        this.play();
      });
    }

    // Handle video state changes
    this.video.addEventListener('play', () => this.updatePlayPauseButton(true));
    this.video.addEventListener('pause', () => this.updatePlayPauseButton(false));
    
    // Handle click on video
    this.video.addEventListener('click', () => this.togglePlayPause());
    
    // Handle keyboard controls
    this.container.addEventListener('keydown', (e) => {
      if (e.code === 'Space') {
        e.preventDefault();
        this.togglePlayPause();
      }
    });

    // Setup iframe API if needed
    if (this.video.tagName === 'IFRAME') {
      this.setupIframeAPI();
    }
  }

  togglePlayPause() {
    if (this.video.tagName === 'IFRAME') {
      this.toggleIframeVideo();
      return;
    }

    if (this.video.paused) {
      this.play();
    } else {
      this.pause();
    }
  }

  play() {
    if (this.video.tagName !== 'IFRAME') {
      try {
        const playPromise = this.video.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.warn('Error attempting to play video:', error);
          });
        }
      } catch (error) {
        console.warn('Error attempting to play video:', error);
      }
    }
    this.updatePlayPauseButton(true);
  }

  pause() {
    if (this.video.tagName !== 'IFRAME') {
      this.video.pause();
    }
    this.updatePlayPauseButton(false);
  }

  updatePlayPauseButton(isPlaying) {
    if (!this.playIcon || !this.pauseIcon) return;
    
    if (isPlaying) {
      this.playIcon.classList.add('hidden');
      this.pauseIcon.classList.remove('hidden');
    } else {
      this.playIcon.classList.remove('hidden');
      this.pauseIcon.classList.add('hidden');
    }
  }

  setupIframeAPI() {
    if (this.video.classList.contains('youtube')) {
      this.setupYouTubeAPI();
    } else if (this.video.classList.contains('vimeo')) {
      this.setupVimeoAPI();
    }
  }

  setupYouTubeAPI() {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    window.onYouTubeIframeAPIReady = () => {
      this.youtubePlayer = new YT.Player(this.video, {
        events: {
          'onStateChange': (event) => {
            this.updatePlayPauseButton(event.data === YT.PlayerState.PLAYING);
          }
        }
      });
    };
  }

  setupVimeoAPI() {
    if (!window.Vimeo) {
      const tag = document.createElement('script');
      tag.src = 'https://player.vimeo.com/api/player.js';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    this.vimeoPlayer = new Vimeo.Player(this.video);
    this.vimeoPlayer.on('play', () => this.updatePlayPauseButton(true));
    this.vimeoPlayer.on('pause', () => this.updatePlayPauseButton(false));
  }

  toggleIframeVideo() {
    if (this.youtubePlayer) {
      const state = this.youtubePlayer.getPlayerState();
      if (state === YT.PlayerState.PLAYING) {
        this.youtubePlayer.pauseVideo();
      } else {
        this.youtubePlayer.playVideo();
      }
    } else if (this.vimeoPlayer) {
      this.vimeoPlayer.getPaused().then(paused => {
        if (paused) {
          this.vimeoPlayer.play();
        } else {
          this.vimeoPlayer.pause();
        }
      });
    }
  }
}

// Initialize controllers when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const videoContainers = document.querySelectorAll('.video-container');
  videoContainers.forEach(container => {
    new VideoController(container);
  });
});

  } catch(e) { console.error(e); }
})();
})();
